import React, { Component, lazy, Suspense } from 'react';
import HomePage from './Components/Home';
import Header from './Components/Header';
import 'typeface-roboto'
import logo from './Images/potrait.webp';
import './Styles/App.css'
const ImageToggle = lazy(() => import('./Components/ImageToggle.js'));
const ContactForm = lazy(() => import('./Components/Contact'));
const renderLoader = () => <p>Loading</p>;


class App extends Component {
  render() {
    return (
      <div className="App">
        <Header />
        <div className="App-Content">
        <header className="App-header">
        <Suspense fallback={renderLoader()}>
          <ImageToggle image={logo} />
        </Suspense>
        <div>
          <h1>Jeton Koka</h1>
        </div>
        </header>
        <div className="App-body">
          <HomePage />
          <Suspense fallback={renderLoader()}>
            <ContactForm />
          </Suspense>
        </div>
        </div>
      </div>
     );
    }
  }


export default App;



// WEBPACK FOOTER //
// ./src/App.js